var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBonusAlreadyClaimed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 505.766 505.766",
    height: 512,
    viewBox: "0 0 505.766 505.766",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_222_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_478_",
    d: "m195.553 310.213-35.038-49.94-52.961-38.059c-4.081 10.758-7.587 20.001-11.667 30.759l33.272 46.633 45.181 31.82 21.212-2.32z",
    fill: "#fc6dae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_479_",
    d: "m131.913 373.853-21.213-33.58-38.148-25.781c-4.08 10.758-7.586 20.001-11.667 30.759l19.373 32.689 30.442 17.126h16.792z",
    fill: "#fc6dae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_493_",
    d: "m174.34 331.426 32.486 44.847 45.967 33.605c10.758-4.08 20.001-7.586 30.759-11.667l-38.726-48.605-49.273-39.393c-7.42 7.419-13.794 13.794-21.213 21.213z",
    fill: "#f73d7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_494_",
    d: "m110.7 395.066 18.126 28.874 31.689 20.941c10.758-4.081 20.001-7.587 30.759-11.667l-25.448-35.002-33.913-24.359c-7.419 7.419-13.794 13.794-21.213 21.213z",
    fill: "#f73d7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_473_",
    d: "m227.372 278.393-42.426-56.179-59.891-46.14c-5.561 14.66-11.94 31.479-17.501 46.14 10.646 10.645 77.283 77.283 87.999 87.999l22.273-8.273z",
    fill: "#ffd92e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_488_",
    d: "m195.553 310.213c10.645 10.645 77.283 77.283 87.999 87.999 14.66-5.561 31.478-11.94 46.138-17.501l-46.138-58.104-56.179-44.213c-10.116 10.115-21.706 21.704-31.82 31.819z",
    fill: "#fcbe00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_325_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_53_",
    d: "m216.765 225.36h-21.212v-21.213c15.196-15.195 33.853-33.852 42.426-42.427 16.998-16.998 26.361-39.599 26.361-63.64 0-24.039-9.362-46.64-26.361-63.639 7.419-7.419 13.794-13.794 21.213-21.213 46.71 46.709 47.088 122.617 0 169.706l-26.517 26.516z",
    fill: "#c6ea4b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_324_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_356_",
    d: "m301.618 310.213h-21.213v-21.213c14.707-14.707 27.73-27.73 42.427-42.427 22.664-22.664 52.798-35.147 84.852-35.147 32.052 0 62.187 12.481 84.853 35.147-7.419 7.419-13.794 13.794-21.213 21.213-17.546-17.545-40.593-26.318-63.64-26.318s-46.093 8.773-63.639 26.318c-14.686 14.685-27.7 27.7-42.427 42.427z",
    fill: "#55c8ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_315_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_65_",
    d: "m146.159 44.606h30v30h-30z",
    fill: "#84dfff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_309_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_379_",
    d: "m176.159 104.606h30v30h-30z",
    fill: "#84dfff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_308_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_403_",
    d: "m386.159 284.606h30v30h-30z",
    fill: "#92e200"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_307_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_538_",
    d: "m446.159 374.606c-10.492 0-19.507 0-30 0 0-10.492 0-30 0-30h30z",
    fill: "#92e200"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_304_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_350_",
    d: "m446.159 134.606h30v30h-30z",
    fill: "#55c8ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_303_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_383_",
    d: "m326.159 14.606h30v30h-30z",
    fill: "#c6ea4b"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_467_",
    d: "m444.472 61.293c7.914-7.914 14.714-14.714 22.628-22.627-11.929 2.25-20.404 10.842-22.628 22.627z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_469_",
    d: "m365.721 140.045c7.915-7.915 14.716-14.716 22.631-22.631-11.928 2.25-20.408 10.844-22.631 22.631z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_470_",
    d: "m388.352 117.414 31.807-21.308 24.314-34.813c2.246-11.902 10.82-20.401 22.628-22.627l22.559-12.06 5.5-16c-3.71-3.709-6.898-6.896-10.607-10.606-14.427 14.426-30.453 2.167-53.516 25.231-18.46 18.459-15.059 35.083-19.239 45.057-2.396 5.72-8.726 12.05-14.449 14.449-7.142 2.994-17.103 2.066-29.089 7.749-11.395 5.403-22.061 16.065-27.466 27.466-8.238 17.375-2.093 25.898-13.741 37.548 3.709 3.71 6.897 6.897 10.606 10.606l14.031-5.5 14.031-22.561c2.256-11.961 10.687-20.378 22.631-22.631z",
    fill: "#fc6dae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_472_",
    d: "m248.585 257.181c-3.155-3.155-108.708-108.708-111.863-111.864-4.081 10.757-7.587 20.001-11.667 30.758 5.687 5.686 96.631 96.632 102.317 102.318l19.547-1.666z",
    fill: "#fcbe00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_475_",
    d: "m60.885 345.251c-1.718 4.529-59.169 155.99-60.885 160.515l60.885-47.159 49.815-63.54c-6.023-6.024-43.753-43.753-49.815-49.816z",
    fill: "#ffd92e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_476_",
    d: "m174.34 331.426c-8.843-8.843-69.135-69.134-78.453-78.453-6.343 16.721-19.629 51.748-23.335 61.519 7.213 7.214 52.126 52.126 59.361 59.361l28.602-14.247z",
    fill: "#ffd92e"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#f73d7f"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_482_",
    d: "m427.02 99.958c12.69-12.69 14.37-22.33 17.452-38.665-19.628 19.627-36.493 36.493-56.12 56.121 15.387-2.903 25.556-4.343 38.668-17.456z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_484_",
    d: "m505.766 21.213c-3.71-3.709-6.897-6.896-10.606-10.606-9.814 9.813-18.246 18.246-28.059 28.06 10.213-1.928 23.777-2.566 38.665-17.454z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_485_",
    d: "m365.721 140.045c-9.815 9.814-18.247 18.248-28.062 28.061 3.709 3.71 6.897 6.897 10.606 10.607 14.392-14.392 15.27-27.086 17.456-38.668z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_487_",
    d: "m329.689 380.711c10.758-4.08 20.001-7.586 30.759-11.667-3.155-3.155-108.707-108.708-111.863-111.863-7.419 7.419-13.793 13.794-21.213 21.213 5.687 5.686 96.631 96.631 102.317 102.317z",
    fill: "#ff9000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_490_",
    d: "m110.7 395.066c-6.141 6.142-104.558 104.558-110.7 110.7 4.529-1.718 155.99-59.168 160.515-60.885-6.023-6.023-43.753-43.753-49.815-49.815z",
    fill: "#fcbe00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_491_",
    d: "m131.913 373.853c7.213 7.213 52.126 52.126 59.361 59.361 16.722-6.343 51.749-19.629 61.519-23.335-8.843-8.843-69.134-69.134-78.453-78.453-5.134 5.134-37.26 37.26-42.427 42.427z",
    fill: "#fcbe00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonusAlreadyClaimed);
export default __webpack_public_path__ + "static/media/bonus-already-claimed.c66b722e03ea7515ca430bc195ee67e2.svg";
export { ForwardRef as ReactComponent };